module.exports = __webpack_public_path__ + "img/白果.58ead71c.jpg";